import { c as _c } from "react/compiler-runtime";
import { HStack, Icon } from '@chakra-ui/react';
import { LuStar } from 'react-icons/lu';
const STAR_SIZES = {
  xs: '3',
  sm: '3.5',
  md: '4'
} as const;
export type SessionReviewStarsProps = {
  /** 1–5 integer stars. */
  score: number;
  size?: keyof typeof STAR_SIZES;
};

/** Read-only 5-star row. Filled stars use `orange.fg` (matches the rating modal). */
export const SessionReviewStars = t0 => {
  const $ = _c(9);
  const {
    score,
    size: t1
  } = t0;
  const size = t1 === undefined ? "sm" : t1;
  let t2;
  if ($[0] !== score) {
    t2 = Math.round(score || 0);
    $[0] = score;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const filled = Math.max(0, Math.min(5, t2));
  const t3 = `${filled} out of 5 stars`;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [1, 2, 3, 4, 5];
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== filled || $[4] !== size) {
    t5 = t4.map(value => <Icon key={value} aria-hidden={true} boxSize={STAR_SIZES[size]} color={value <= filled ? "orange.fg" : "fg.subtle"} css={{
      "& path, & polygon": {
        fill: value <= filled ? "currentColor" : "none"
      }
    }}><LuStar /></Icon>);
    $[3] = filled;
    $[4] = size;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <HStack aria-label={t3} gap={0.5} role="img">{t5}</HStack>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};